import { runInAction } from 'mobx';
import { requestDelete } from '../../../services/real.backend';
import usersStorage from '../../../pages/Users/usersStorage';

export default function deleteUsers(id) {
  const userIDs = {
    users: [],
  };
  if (typeof id === 'string') userIDs.users.push(id);
  if (typeof id === 'number') userIDs.users.push(id);
  if (id instanceof Array) userIDs.users = id;
  return requestDelete('/api/users', userIDs)
    .then((resp) => {
      if (resp && resp.users) {
        runInAction(() => {
          Object.keys(resp.users).map((user) => {
            const found = usersStorage.users.findIndex((u) => u.id == user);
            if (found >= 0) {
              usersStorage.users[found].deleted_at = resp.users[user];
            }
          });
          // usersStorage.users = usersStorage.users.filter((user) => {
          //   const found = resp.users.findIndex((u) => u == user.id) >= 0;
          //   return !found;
          // });
          usersStorage.users = [...usersStorage.users];
          // usersStorage.setCurrentUser(null);
        });
      }
    });
}
